import { z } from 'zod';

export const BigTimePeriodComparison = z
  .enum(['none', 'previous_time_period', 'previous_year'])
  .describe('BigTimePeriodComparison');

export type BigTimePeriodComparison = z.infer<typeof BigTimePeriodComparison>;

export const BigTimePeriodComparisonOptions = Object.values(
  BigTimePeriodComparison.Values,
);

export const bigTimePeriodComparisonToText: Record<
  BigTimePeriodComparison,
  string
> = {
  none: 'None',
  previous_time_period: 'Previous Time Period',
  previous_year: 'Previous Year',
};

export const BigTimePeriodComparisonDropdownOptions =
  BigTimePeriodComparisonOptions.map((option) => ({
    optionValue: option,
    optionLabel: bigTimePeriodComparisonToText[option],
  }));
